import { Controller } from 'stimulus';

class QuotationItemController extends Controller {
  onRemoveClick() {
    this.removeItem().then(() => this.removeItemFromDOM());
  }

  removeItemFromDOM() {
    $(this.element).remove();
    window.location.reload();
  }

  removeItem() {
    return $.ajax({
      url: window.app.api.quotationItemDestroy,
      type: 'DELETE',
      data: {
        id: this.data.get('id'),
      },
    });
  }
}

QuotationItemController.targets = [];

export default QuotationItemController;
